import { isStaffRole } from "@/lib/permissions/roles";

/**
 * Controls debug UI (debug menu). Admins and support can access it in production;
 * development and the explicit env override keep the menu available in local/dev.
 * Membership-plan spoofing stays admin/dev-only in the panel itself.
 */
export function shouldShowDebugToolbar(userRole?: "user" | "support" | "admin" | null): boolean {
	return (
		isStaffRole(userRole) ||
		process.env.NEXT_PUBLIC_ENABLE_DEBUG_MENU === "true" ||
		process.env.NODE_ENV === "development"
	);
}
